import React from "react";
import LatestUpdate from "../../common/LatestUpdate";
import parse from "html-react-parser";

const ArticleContent = ({ content, toolsClass }) => {
  return (
    <div className="max-w-[1200px] flex flex-col lg:flex-row justify-between lg:items-start gap-8">
      <div className=" max-w-[789px] flex flex-col gap-5 max-sm:px-4 max-xl:px-6">
        {content.map((item, index) => (
          <div key={index} className="flex flex-col gap-4 text-darkGray">
            <h3 className="text-base sm:text-xl lg:text-2xl font-bold">
              {item.title}
            </h3>

            {Array.isArray(item.content) && (
              <div className="flex flex-col gap-7 lg:gap-4 whitespace-pre-line">
                {item.content.map((desc, idx) => {
                  if (desc.indexOf('<ul>') === 0) {
                    return parse(desc);
                  }

                  return (
                    <p
                      key={idx}
                      className="text-base lg:text-lg text-darkGray/70"
                    >
                      {parse(desc)}
                    </p>
                  );
                })}
              </div>
            )}
            {item.tools && (
              <ul className="list-disc pl-5">
                {item.tools.map((tool, idx) => (
                  <li key={idx} className="text-lg text-darkGray/70 mb-4">
                    <span className={toolsClass}>{tool.name}</span> :{" "}
                    {tool.description}
                  </li>
                ))}
              </ul>
            )}
            {item.content2 &&
              item.content2.map((desc, idx) => (
                <p key={idx} className="text-lg text-darkGray/70">
                  {parse(desc)}
                </p>
              ))}

            {item.singleLine && (
              <span className="text-darkPurple text-base sm:text-lg font-bold sm:mt-4">
                {item.singleLine}
              </span>
            )}
            {item.Heading && (
              <span className="text-darkGray text-base sm:text-lg font-bold whitespace-pre-line mt-4">
                {item.Heading}
              </span>
            )}
          </div>
        ))}
      </div>

      <div className="w-full lg:max-w-[379px] flex-1 pt-[80px] lg:pt-[200px] article-connect">
        <LatestUpdate className="py-0" smallContainer={true} />
      </div>
    </div>
  );
};

export default ArticleContent;
